import * as style from "../../pages/ApplicationList/ApplicationList.module.scss";
import Typography from "../Common/CprimeText";
import React, { useEffect, useState } from "react";
import { Divider, TextArea, TextInput } from "cprime-foundational-components";
import Button from "../Common/CprimeButton";
import { triggerToast } from "../../utils/toast";
import {
  createContext,
  deleteContext,
  editContext,
} from "../../services/RequestAccess/RequestAccess";

interface ManageContextProps {
  isEdit: boolean;
  appId: number;
  formData: any;
  onClose: any;
  incrementTableRefresh: any;
}

const ManageContext: React.FC<ManageContextProps> = ({
  isEdit,
  appId,
  formData,
  onClose,
  incrementTableRefresh,
}) => {
  const scssClass = style as any;
  const [contextForm, setContextForm] = useState<any>({
    name: "",
    description: "",
  });
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if (isEdit) {
      setContextForm({
        ...contextForm,
        name: formData?.context_name ?? "",
        description: formData?.description ?? "",
      });
    } else {
      setContextForm({
        name: "",
        description: "",
      });
    }
  }, [isEdit, formData]);

  const handleChange = (field: string, value: string) => {
    setContextForm((prev: any) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (isEdit === false) {
      setLoading(true);
      const body = {
        app_id: appId,
        context_name: contextForm?.name,
        description: contextForm?.description,
      };
      try {
        const result = await createContext(body);
        if (result?.status === "SUCCESS") {
          const message = result?.message || "Context created successfully";
          triggerToast(message, "success");
          onClose();
          incrementTableRefresh?.();
        } else {
          triggerToast(result?.message, "error");
        }
      } catch (error) {
        triggerToast("Error Creating Context", "error");
      } finally {
        setLoading(false);
      }
    }
    if (isEdit === true) {
      setLoading(true);
      if (!formData?.id) {
        triggerToast("Something went wrong", "error");
        setLoading(false);
        return;
      }
      const body = {
        context_id: formData?.id,
        context_name: contextForm?.name,
        description: contextForm?.description,
      };
      try {
        const result = await editContext(body);
        if (result?.status === "SUCCESS") {
          const message = result?.message || "Context updated successfully";
          triggerToast(message, "success");
          onClose();
          incrementTableRefresh?.();
        } else {
          triggerToast(result?.message, "error");
        }
      } catch (error) {
        triggerToast("Error Updating Context", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleDelete = async () => {
    if (isEdit === true) {
      setDeleteLoading(true);
      if (!formData?.id) {
        triggerToast("Something went wrong", "error");
        setDeleteLoading(false);
        return;
      }
      try {
        const result = await deleteContext(formData?.id);
        if (result?.status === "SUCCESS") {
          const message = result?.message || "Context deleted successfully";
          triggerToast(message, "success");
          onClose();
          incrementTableRefresh?.();
        } else {
          triggerToast(result?.message, "error");
        }
      } catch (error) {
        triggerToast("Error deleting Context", "error");
      } finally {
        setDeleteLoading(false);
      }
    }
  };

  const isFormValid = () => {
    if (isEdit) {
      return (
        (contextForm?.name === formData?.context_name &&
          contextForm?.description === formData?.description) ||
        !(contextForm?.description && contextForm?.name)
      );
    } else {
      return !(contextForm?.name && contextForm?.description);
    }
  };

  return (
    <>
      <div className={scssClass.panelContent}>
        <Divider
          variant={"fullWidth"}
          sx={{
            marginBottom: "15px",
            width: "100%",
            marginLeft: "0px !important",
            backgroundColor: "#f8f8f9 !important",
          }}
        />
        <Typography
          sx={{
            fontSize: "14px",
            mb: "1.5rem",
          }}
        >
          Create a context that can be added to Roles in this Application to
          give more insight into their purpose.
        </Typography>
        <Typography className={scssClass.textDescription}>
          Context Details
        </Typography>
        <div className={scssClass.fieldsContent}>
          <div className={scssClass.firstRow}>
            <TextInput
              value={contextForm?.name}
              fullWidth
              sx={{
                width: "100%",
                // "& .MuiInputBase-input": { padding: "0.75rem 1rem" },
                // "& .MuiInputBase-root": { height: "39.98px" },
              }}
              onChange={(e) => handleChange("name", e?.target?.value)}
              placeholder="Input Text"
              label="Name"
              maxLength={100}
            />
          </div>
          <div className={scssClass.secondRow}>
            <TextArea
              fullWidth
              placeholder="Input Text"
              label="Description"
              value={contextForm?.description}
              onChange={(e) => handleChange("description", e?.target?.value)}
              maxLength={100}
            />
          </div>
        </div>
      </div>
      <div className={scssClass.bottomPanel}>
        <Divider
          variant="fullWidth"
          sx={{
            marginBottom: "15px",
            width: "100%",
            marginLeft: "0px !important",
            backgroundColor: "#f8f8f9 !important",
          }}
        />
        <div className={scssClass.footerButtons}>
          <div>
            {isEdit && (
              <Button
                variant="danger"
                onClick={handleDelete}
                loading={deleteLoading}
              >
                Delete Context
              </Button>
            )}
          </div>
          <div>
            <Button
              variant="tertiary"
              sx={{ marginRight: "10px" }}
              onClick={() => onClose?.()}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              sx={{ marginLeft: "5px" }}
              onClick={handleSave}
              disabled={isFormValid()}
              loading={loading}
            >
              Save Context
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default ManageContext;
